import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CDSMask } from '@app/utils/cds-mask';

import { Conta } from '@app/models/conta.model';
import { MovimentacaoFinanceira } from '@app/models/movimentacao-financeira.model';
import { LancamentoService } from '@app/services/lancamento.service';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ToastrService } from 'ngx-toastr';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ParticipanteService } from '@app/services/participante.service';

@Component({
  selector: 'app-transferencia-form',
  templateUrl: 'transferencia-form.component.html'
})

export class TransferenciaFormComponent implements OnInit {

  movimentacao: MovimentacaoFinanceira[] = [];

  cdsMask: CDSMask = new CDSMask();
  lstErros: string[] = [];
  carregandoDados = true;

  titulo: string;
  conta: Conta = new Conta();

  lstConta: IdDescricao[];
  lstFormaDePagamento: IdDescricao[] = [];
  lstTipoDR: IdDescricao[] = [];

  transferencia: boolean;

  aguardandoSolicitacao = false;
  movimentarTodosOsCaixas: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private movimentoService: LancamentoService,
    private consultasService: ConsultasService,
    private participanteService: ParticipanteService,
    @Inject(ToastrService) public toastr: ToastrService,

  ) {
    for (let i = 0; i < 2; i++) {
      this.movimentacao[i] = <MovimentacaoFinanceira>({
        Id: 0,
        Valor: 0,
        ContaId: 0,
        CreditoDebito: i === 0 ? 'D' : 'C',
        FormaDePagamentoId: null,
        DemonstrativoDeResultadoId: null
      });
    }

  }

  ngOnInit(): void {
    this.carregaDadosInicias();
    this.titulo = 'Nova Transferência';

    this.movimentacao[0].DataLancamento = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    this.movimentacao[0].DataCompetencia = UtilitarioService.retornaDataAtualMaisDiasISO(0);
  }

  async carregaDadosInicias() {

    const chamadas = [
      this.participanteService.verificaPermissaoUsuario(0, 'MovimentarTodosOsCaixas'),
      this.consultasService.consultar('FORMADEPAGAMENTO'),
      this.consultasService.consultar('DR')
    ];

    const [data1, data2, data3] = await Promise.all(chamadas);

    data1.subscribe(data => {
      this.movimentarTodosOsCaixas = data;
      this.consultasService.consultar('CONTA').subscribe((data) => this.lstConta = data);
    },
    () => this.consultasService.consultar('CONTA_USUARIO').subscribe((data) => this.lstConta = data));
    data2.subscribe(data => this.lstFormaDePagamento = data);
    data3.subscribe(data => this.lstTipoDR = data);

    this.carregandoDados = false;
  }

  populaFormaDePagamento() {
    this.lstFormaDePagamento.forEach(item => {
      if (item.Descricao.includes('Débito')) 
        this.movimentacao[0].FormaDePagamentoId = item.Id;
      else if (item.Descricao.includes('Crédito')) 
        this.movimentacao[1].FormaDePagamentoId = item.Id;
    });
  }

  async gravar(i: number) {

    if (i === 0) {
      this.populaVazios();
    }

    const movimentacao = { ...this.movimentacao[i] };
    movimentacao.DemonstrativoDeResultado = null;
    this.movimentoService.gravar(movimentacao)
      .toPromise().then(() => {
        if (i === 1) {
          setTimeout(() => this.toastr.success('No valor de R$' + String(movimentacao.Valor), 'Transferência concluída!'), 700);
          this.router.navigate(['/financeiro/lancamento']);
        }
      }
        ,
        // this.toastr.info( (i === 0) ? 'Débito...' : 'Crédito...', 'Aguarde')
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
            if (i === 1) {
              this.toastr.error('Ocorreu algum erro...');
            }
            this.aguardandoSolicitacao = false;
          }
        });

  }

  btnVoltar() {
    window.history.go(-1);
  }

  searchCallback = () => true;

  populaVazios() {
    this.movimentacao[1].Documento = this.movimentacao[0].Documento;
    this.movimentacao[1].Valor = this.movimentacao[0].Valor;
    this.movimentacao[1].DemonstrativoDeResultadoId = this.movimentacao[0].DemonstrativoDeResultadoId;
    this.movimentacao[1].DataCompetencia = this.movimentacao[0].DataCompetencia;
    this.movimentacao[1].DataLancamento = this.movimentacao[0].DataLancamento;
    this.movimentacao[1].Historico = this.movimentacao[0].Historico;
    this.populaFormaDePagamento();
  }

  salvar() {
    const validaContaId = () => {
      let erro: boolean = false;
      this.movimentacao.forEach(item => {
        if (item.ContaId === null || item.ContaId === 0) {
          this.toastr.warning('Selecione as contas corretamente', 'Aviso:');
          erro = true;
        }
      });
      return erro;
    };
    const validaValor = () => {
      let erro: boolean = false;
      let valoresPreenchido = this.movimentacao.filter(item => item.Valor !== 0).length;
      if (valoresPreenchido === 0) {
        this.toastr.warning('O valor da transferência deve ser maior do que zero', 'Aviso:');
        erro = true;
      }

      return erro;
    };
    
    this.aguardandoSolicitacao = true;
    
    let erroContaId: boolean = validaContaId();
    let erroValor: boolean = validaValor();
    if (erroContaId || erroValor) {
      this.aguardandoSolicitacao = false;
      return;
    }
    this.gravar(0)
      .then(() => 
        this.gravar(1)
          .catch(() => this.toastr.error('Transferência falhou (Crédito)', 'Erro:'))
      ).catch(() => this.toastr.error('Transferência falhou (Débito)', 'Erro:'))
      .then(() => this.btnVoltar);
  }

}
